import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable, of, throwError} from "rxjs";


@Injectable()
export class GlobalErrorHandlingService {
  
  constructor() {}

  /**
   * Handle HTTP operation failures gracefully.
   * @param operation - The name of the operation that failed.
   * @param result - The fallback result if an error occurs.
   */
  public handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse): Observable<T> => {

      let errorMessage = `${operation} failed: ${error.message}`;

      if (error.error instanceof ErrorEvent) {
        // Client-side error (e.g., network issue, CORS, etc.)
        errorMessage = `Client-side error: ${error.error.message}`;
      } else {
        // Server-side error (HTTP response codes)
        errorMessage = `Server returned code ${error.status}: ${error.message}`;
      }

      // Handle Specific HTTP Errors
      switch (error.status) {
        case 0: // No response from the server (e.g., server down, CORS issues)
          errorMessage = 'Unable to connect to the server. Please check your internet connection.';
          break;
        case 401: // Unauthorized
          errorMessage = 'Unauthorized. Please log in again.';
          break;
        case 403: // Forbidden
          errorMessage = 'Access denied. You do not have permission to perform this action.';
          break;
        case 404: // Not Found
          errorMessage = 'Requested resource not found.';
          break;
        case 500: // Internal Server Error
          errorMessage = 'An unexpected error occurred on the server. Please try again later.';
          break;
      }

      // Log errors (this can be sent to a remote monitoring service)
      console.error(`${operation} Error: ${errorMessage}`);

      // For certain errors, return an empty result instead of throwing an exception
      if (error.status === 404 || error.status === 200) {
        return of(result as T);
      }

      // Throw an error observable for other cases
      return throwError(() => new Error(errorMessage));
    };
  }
}
